import { Component } from '@angular/core';

@Component({
  selector: 'lib-web-shared-ui-lib-promotion-preview',
  imports: [],
  templateUrl: './lib-promotion-preview.component.html',
  styleUrl: './lib-promotion-preview.component.scss',
})
export class LibPromotionPreviewComponent {}
